import Vue from "vue";

class ErrorService {
	stopProcessingOnFail(context) {
		Vue.prototype.$bus.trackEvent("error-catched", () => {
			if (context.formProcessing) context.formProcessing = false;

			if (context.isProcessing) context.isProcessing = false;
		});
	}
}

export default new ErrorService();
